// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import CampaignForm from '../../common/CampaignForm';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    minHeight: '500px',
    paddingTop: theme.spacing(3),
  },
}));

function CampaignDetailsPage(props) {
  const [t] = useTranslation();
  const classes = useStyles();
  const today = new Date();

  const {
    campaign,
    series,
    products,
    onUpdateCampaign,
    onGoBack,
    actionsDisabled,
    onCloseCampaign,
  } = props;

  const isActive =
    campaign.state === 'ACTIVE' &&
    !series.some(s => new Date(s.endDate).getTime() > today.getTime());

  return (
    <Box id="CampaignDetailsTab-container" className={classes.container}>
      <CampaignForm
        campaign={campaign}
        products={products}
        onSave={onUpdateCampaign}
        onCancel={onGoBack}
        cancelButtonText={t('common.back')}
        cancelButtonIcon="chevron_left"
        actionsDisabled={actionsDisabled}
        onCloseCampaign={onCloseCampaign}
        editMode
        isActive={isActive}
      />
    </Box>
  );
}

CampaignDetailsPage.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    type: PropTypes.string,
    created: PropTypes.string,
    code: PropTypes.string,
    discountDays: PropTypes.number,
    discountEndDate: PropTypes.string,
    discountType: PropTypes.String,
    discountValue: PropTypes.number,
    autoCancel: PropTypes.bool,
    productId: PropTypes.number,
    flowType: PropTypes.string,
    productTitle: PropTypes.string,
    description: PropTypes.string,
    state: PropTypes.string,
  }).isRequired,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      campaignId: PropTypes.number,
      title: PropTypes.string,
      startDate: PropTypes.string,
      prefix: PropTypes.string,
      endDate: PropTypes.string,
      exported: PropTypes.bool,
      voucherCount: PropTypes.number,
      voucherRedeemed: PropTypes.number,
      description: PropTypes.string,
      segment: PropTypes.shape({
        code: PropTypes.string,
        title: PropTypes.string,
      }),
    })
  ).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  onUpdateCampaign: PropTypes.func.isRequired,
  onCloseCampaign: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default CampaignDetailsPage;
